import axios from "axios";
import { getApiBaseUrl } from "../../config";
const apiPrefix = getApiBaseUrl("auth");

export const saveModifyConfiguration = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/save-or-modify-config`,
    reqBody,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const getConfiguration = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/view-config`, reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
